import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Site } from 'src/app/model/site';
import { Observable, Subscription } from 'rxjs';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { LOCALSTORAGE_CURRENT_SITE_ID } from 'src/app/conf/user';
import * as SiteActions from 'src/app/store/site/site.actions';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectTopbarTitle } from 'src/app/store/notifications/notifications.selector';
import { AppComponent } from 'src/app/app.component';
import { Lang } from 'src/app/model/lang';
import { DEFAULT_LANG, LANGUAGES } from 'src/app/conf/languages';
import { User } from 'src/app/model/user';
import { selectCurrentLang, selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	selector: 'app-permissions',
	templateUrl: './permissions.component.html',
	providers: [],
})

export class PermissionsComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;

	titleSel$: Observable<string>;
	titleSub: Subscription | undefined;
	titleId = '';

	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	currentSiteId: number;
	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	isImpersMode: boolean;

	site: Site;

	analytics = this.app.initFirebase();

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		public app: AppComponent
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.subscribeAll();
		this.onResize();

		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Permissions' } }));
		}, 2000);
	}

	ngOnDestroy(): void {
		this.siteSub?.unsubscribe();
		this.titleSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
	}

	initSelectors(): void {
		// Store selectors
		this.site$ = this.store.select(selectCurrentSite);
		this.titleSel$ = this.store.select(selectTopbarTitle);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.currentUser$ = this.store.select(selectUser);
	}

	subscribeAll(): void {

		this.siteSub = this.site$?.subscribe((currentSite) => {
			this.site = currentSite;
			const lsSiteId = localStorage.getItem(LOCALSTORAGE_CURRENT_SITE_ID);
			if (lsSiteId) {
				this.currentSiteId = parseInt(lsSiteId, 10);
			} else {
				this.currentSiteId = currentSite.Id;
			}
			this.store.dispatch(SiteActions.setCurrentSite({ siteId: this.currentSiteId }));
		});
		this.titleSub = this.titleSel$.subscribe(
			(title: string) => {
				this.titleId = title;
			}
		);
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive() {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}
}
